/* istanbul ignore next */
if (typeof rcm != 'undefined') {
    // RCM is undefined in unit tests
    rcm.addAngularModule('app-ui-ship-method-rules');
}
angular.module(
    'app-ui-ship-method-rules',
    [
        'pascalprecht.translate',
        'pipe-rat-js',
    ]
);
